import { i18n } from "@/library/third-party/i18n";

export const DAYS_CONSTANT = [i18n.t("Sunday"), i18n.t("Monday"), i18n.t("Tuesday"), i18n.t("Wednesday"), i18n.t("Thursday"), i18n.t("Friday"), i18n.t("Saturday")];

export const MONTHS_CONSTANT = [
  i18n.t("January"),
  i18n.t("February"),
  i18n.t("March"),
  i18n.t("April"),
  i18n.t("May"),
  i18n.t("June"),
  i18n.t("July"),
  i18n.t("August"),
  i18n.t("September"),
  i18n.t("October"),
  i18n.t("November"),
  i18n.t("December"),
];
